<template>
  <p class="help">Un changement est pris en compte par les utilisateurs du groupe à leur prochaine connexion.</p>
  <ul class="options">
    <li v-for="option in options" :key="option.name" class="option" :class="{owned: option.owned}">
      <div class="option-text">
        <strong class="option-title">{{ option.title }}</strong>
        <code class="option-name">{{ option.name }}</code>
        <span v-if="option.state === 'DEACTIVATED'" class="tag">Désactivée</span>
        <p v-if="option.description" class="option-description">{{ option.description }}</p>
      </div>
      <span class="option-price">{{ option.price }} €/mois</span>
      <div class="option-action">
        <CustomButton :params="buttonOf(option)" :isSecondary="option.owned" :isCompact="true" @click="change(option)" />
      </div>
    </li>
  </ul>
  <RemoveGroupOptionModal ref="removeModal" :callback=callback />
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import {NotificationService} from "@vues/v-common";
import RemoveGroupOptionModal from "@/administration/components/modals/RemoveGroupOptionModal.vue";
import {AdministrationController} from "@/administration/controllers/AdministrationController";

/**
 * Les options existantes, celles du groupe en premier plan : ajout immédiat, retrait après confirmation.
 */
export default {
  name: 'GroupOptions',
  props: ['group', 'options', 'callback'],
  components: {CustomButton, RemoveGroupOptionModal},
  data() {
    return {
      // Nom de l'option dont le changement est en cours : aucun autre changement tant que le back n'a pas répondu
      busy: undefined,
    };
  },
  methods: {
    buttonOf(option) {
      return {text: option.owned ? 'Retirer' : 'Ajouter', disabled: !!this.busy, loading: this.busy === option.name};
    },
    change(option) {
      if (this.busy) return;
      if (option.owned)
        this.$refs.removeModal.openModal(this.group, option);
      else
        this.add(option);
    },
    async add(option) {
      this.busy = option.name;
      const res = await AdministrationController.addOption(this.group.id, option.name);
      this.busy = undefined;
      if (!res.errors) {
        (new NotificationService).addNotification("success", `Option « ${option.title} » ajoutée au groupe`);
        this.callback();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.help
  margin 0 0 12px
  font-size 12.5px
  color CTRL_TEXT_MUTED

.options
  margin 0
  padding 0
  list-style none

.option
  display flex
  align-items center
  gap 16px
  padding 12px 4px
  border-top 1px solid #eef1f6

  &:first-child
    border-top none

.option-text
  flex 1
  min-width 0
  overflow-wrap anywhere

.option-title
  color THEME_COLOR_PRIMARY

.option-name
  margin-left 8px
  font-size 12px
  color CTRL_TEXT_MUTED

  // The technical name goes under the title on a small screen
  @media only screen and (max-width: TABLET_SIZE)
    display block
    margin-left 0

.option-description
  margin 3px 0 0
  font-size 12.5px
  color CTRL_TEXT_MUTED

.option-price
  flex none
  white-space nowrap
  font-size 13px
  color CTRL_TEXT_MUTED

.option.owned .option-price
  font-weight 600
  color THEME_COLOR_PRIMARY

// The button takes the whole width of its container
.option-action
  flex none
  width 110px

  @media only screen and (max-width: TABLET_SIZE)
    width 90px

.tag
  margin-left 8px
  padding 1px 8px
  font-size 11.5px
  font-weight 600
  color #8a5a00
  background #fff6e0
  border 1px solid #f0d9a3
  border-radius 20px
</style>
